import { getJq } from "./jquery-shim.js";

const patternFacesRedirect = /\u003c!--__FACES_REDIRECT__\[\[(.+)]]__-->/;

// If you see this code after the portal was released:
// Look at UserPortalRouter.java, method ajaxRedirectFallback
// If that method is still unused with a TODO comment, you can also
// delete this file. Otherwise, remove this comment.

/**
 * @param {JQuery.jqXHR} xhr
 */
function handleAjaxResponse(xhr) {
  try {
    const match = xhr.responseText?.match(patternFacesRedirect);
    if (match) {
      const url = match[1];
      if (typeof url === "string" && url.length > 0) {
        window.location.href = url;
      }
    }
  } catch (e) {
    console.error("Could not handle AJAX response", e);
  }
}

/**
 * Checks if a JQuery AJAX request settings object has a parameter with the given name and value.
 * @param {JQuery.AjaxSettings} settings Settings object from a JQuery AJAX request.
 * @param {string} name Parameter name.
 * @param {string} value Parameter value.
 * @returns {boolean} True if the parameter is present with the given value.
 */
function hasParam(settings, name, value) {
  const data = settings.data;
  if (data === undefined) {
    return false;
  }
  if (typeof data === "string") {
    return data.includes(`${encodeURIComponent(name)}=${encodeURIComponent(value)}`);
  }
  if (data instanceof FormData || data instanceof URLSearchParams) {
    return data.has(name) && data.get(name) === value;
  }
  if (typeof data === "object") {
    return data[name] === value;
  }
  return false;
}

export function registerAjaxHandler() {
  getJq().ajaxPrefilter("xml", (_options, originalOptions, jqXHR) => {
    if (hasParam(originalOptions, "javax.faces.partial.ajax", "true")) {
      jqXHR.always(() => handleAjaxResponse(jqXHR));
    }
  });
}
